import { Injectable } from '@angular/core';
import { DateFormatPipe, UtcPipe } from 'ngx-moment';
import { ControlService } from '../../control/control.service';
import { IControlDeviceModel, IDeviceModel } from '../models/models';
import { ControlSubRouteFactoryService } from './control-sub-route-factory.service';
import { DeviceModelService } from './device-model.service';
import { DynamicDeviceModel } from '../models/dynamic-device-model';

@Injectable({
    providedIn: 'root'
})
export class DeviceModelFactoryService {
    public static $name = 'deviceModelFactory';

    constructor(
        private controlService: ControlService,
        private controlSubRouteFactory: ControlSubRouteFactoryService,
        private deviceModelService: DeviceModelService,
        private dateFormatPipe: DateFormatPipe,
        private utcPipe: UtcPipe,
    ) {
    }

    public createDynamic(
        hardwareCategory: string,
        data: IControlDeviceModel,
        areaId: number,
        locationId: number,
        eventless: boolean = false
    ): IDeviceModel {

        const deviceModel = new DynamicDeviceModel(
            this.controlService,
            this.deviceModelService,
            this.dateFormatPipe,
            this.utcPipe,
        );

        deviceModel.eventless = eventless;

        deviceModel.initialize({
            areaId: areaId,
            locationId: locationId,
            descriptor: data.descriptor,
            modelName: hardwareCategory,
            subroutes: this.controlSubRouteFactory.getSubroutes(hardwareCategory),
            controls: data.controls
        });

        return deviceModel;
    }
}
